import React from 'react';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { NavLink } from 'react-router-dom';
import withBreadcrumbs from 'react-router-breadcrumbs-hoc';
import { styles } from './styles';
import { useBreadcrumb } from '../../../context/breadcrumb';

const BreadcrumbsList = withBreadcrumbs()(({ breadcrumbs }) => {
  const classes = styles();
  let { routes } = useBreadcrumb();

  // if (breadcrumbs.length > routes.length) {
  //   routes = JSON.parse(sessionStorage.getItem('routes'));
  // }

  //   routes && routes.findIndex((r) => r.key === applicationEntryRoute.key) !== -1
  //     ? routes
  //     : JSON.parse(sessionStorage.getItem('breadcrumbRoutes'));
  // sessionStorage.setItem('breadcrumbRoutes', JSON.stringify(breadcrumbRoutes));

  const currentBreadCrumb = breadcrumbs[breadcrumbs.length - 1];

  if (routes) {
    // eslint-disable-next-line
    routes.splice(
      // eslint-disable-next-line no-prototype-builtins
      routes.findIndex((x) => x.hasOwnProperty('active') && x.active) + 1,
      routes.length,
    );
  } else {
    routes = [];
  }
  return (
    <div className={classes.root}>
      {
        <Breadcrumbs
          className={classes.breadcrumb}
          separator={<span className={classes.separator}>›</span>}
          aria-label="breadcrumb"
        >
          {routes.map((bcr, index) => {
            const isLast = index === routes.length - 1;
            return (
              <div key={bcr.path}>
                <span key={bcr.path}>
                  {/* {index === 0 ? (
                      <Button
                        size="medium"
                        className={classes.buttonStyle}
                        onClick={() => {
                          if (currentBreadCrumb.key === 'simulationResults') {
                            //navigate to simulation result page
                            history.push('/simulations');
                          } else {
                            history.goBack();
                          }
                        }}
                      >
                        <span className={classes.backNaviIcon}>{`${'<'}`}</span>
                        <span className={classes.backNaviText}>back</span>
                      </Button>
                    ) : null} */}
                  {
                    // Object.keys(match.params).length === 0 &&
                    isLast ? (
                      <Typography
                        component="div"
                        className={classes.activeBreadcrumbLink}
                      >
                        <Box m={1}>
                          {bcr.name}
                        </Box>
                      </Typography>
                    ) : (
                      <Button
                        color="primary"
                        size="large"
                        className={classes.buttonStyle}
                      >
                        <NavLink
                          to={bcr.path}
                          className={classes.breadCrumbLink}
                        >
                          {bcr.name}
                        </NavLink>
                      </Button>
                    )
                  }
                </span>
              </div>
            );
          })}
        </Breadcrumbs>
      }
    </div>
  );
});
export default BreadcrumbsList;
